import './locator-cbo-controller';
import './locator-operadora-anterior-controller';
import './locator-local-atendimento-controller';
import './locator-beneficiarios-controller';
import './locator-procedimento-controller';
import './locator-municipio-controller';
